import { ORGANIZATION_BRAND } from './organization';

export const ROUTE_PATHS = {
  login: '/giris',
  dashboard: '/anasayfa',
  announcements: '/duyurular',
  directory: '/personel-rehberi',
  documents: '/dokuman-merkezi',
  cafeteria: '/yemekhane',
  userRegistration: '/kullanici-kayit',
  hr: '/insan-kaynaklari',
  applications: '/basvurular',
  newEmployee: '/yeni-calisan',
  allEmployees: '/tum-calisanlar',
  profile: '/profil',
  events: '/etkinlik-takvimi',
  surveys: '/anketler',
  innovation: '/inovasyon-oneri',
  administrative: '/idari-isler',
  selfService: '/operasyonel-servisler',
  administrativeRequests: '/idari-isler-talepler',
  administrativeStats: '/idari-isler-istatistikler',
  inventory: '/zimmet-yonetimi',
  inventoryList: '/zimmet-listesi',
  newInventory: '/yeni-zimmet',
  inventoryReports: '/zimmet-raporlari',
  companyManagement: '/firma-yonetimi',
  contentAdmin: '/icerik-yonetimi'
};

export const LEGACY_ROUTE_REDIRECTS = [
  { from: '/dokumanlar', to: ROUTE_PATHS.documents },
  { from: '/personel', to: ROUTE_PATHS.directory }
];

export const PAGE_TITLES = {
  [ROUTE_PATHS.dashboard]: 'Anasayfa',
  [ROUTE_PATHS.announcements]: 'Duyurular',
  [ROUTE_PATHS.directory]: 'Çalışan Rehberi',
  [ROUTE_PATHS.documents]: 'Doküman Merkezi',
  [ROUTE_PATHS.cafeteria]: 'Yemekhane',
  [ROUTE_PATHS.userRegistration]: 'Kullanıcı Kayıt',
  [ROUTE_PATHS.hr]: 'İnsan Kaynakları',
  [ROUTE_PATHS.applications]: 'Başvurular',
  [ROUTE_PATHS.newEmployee]: 'Yeni Çalışan Kaydı',
  [ROUTE_PATHS.allEmployees]: 'Tüm Çalışanlar',
  [ROUTE_PATHS.profile]: 'Profil',
  [ROUTE_PATHS.events]: 'Etkinlik Takvimi',
  [ROUTE_PATHS.surveys]: 'Anketler',
  [ROUTE_PATHS.innovation]: 'Öneri ve Talep Kutusu',
  [ROUTE_PATHS.administrative]: 'İdari İşler',
  [ROUTE_PATHS.selfService]: 'Operasyonel Servisler',
  [ROUTE_PATHS.administrativeRequests]: 'İdari İşler Talepleri',
  [ROUTE_PATHS.administrativeStats]: 'İdari İşler İstatistikleri',
  [ROUTE_PATHS.inventory]: 'Zimmet Yönetimi',
  [ROUTE_PATHS.inventoryList]: 'Zimmet Listesi',
  [ROUTE_PATHS.newInventory]: 'Yeni Zimmet',
  [ROUTE_PATHS.inventoryReports]: 'Zimmet Raporları',
  [ROUTE_PATHS.companyManagement]: 'Firma Yönetimi',
  [ROUTE_PATHS.contentAdmin]: 'İçerik Yönetimi'
};

export const NAVIGATION_GROUPS = [
  {
    key: 'duyurular',
    label: 'Duyurular',
    icon: 'bx bxs-buildings',
    description: 'Şirket içi iletişim ve temel bilgi alanları',
    items: [
      { key: 'announcements', label: 'Duyurular', path: ROUTE_PATHS.announcements, requiresCompanyScope: true }
      // Anketler müşteri talebiyle geçici olarak menüden gizlendi (2026-07-01) —
      // rota (surveys) aktif kalıyor, ileride geri eklenebilir.
      // { key: 'surveys', label: 'Anketler', path: ROUTE_PATHS.surveys }
    ]
  },
  {
    key: 'dokuman-merkezi',
    label: 'Doküman Merkezi',
    icon: 'bx bxs-file-doc',
    path: ROUTE_PATHS.documents,
    description: 'Politika, prosedür, form ve şablonlar için merkezi erişim',
    items: [
      { key: 'documents', label: 'Doküman Merkezi', path: ROUTE_PATHS.documents }
    ]
  },
  {
    key: 'calisan-rehberi',
    label: 'Çalışan Rehberi',
    icon: 'bx bxs-group',
    description: 'Fotoğraflı ekip rehberi ve departman görünümü',
    items: [
      { key: 'directory', label: 'Çalışan Rehberi', path: ROUTE_PATHS.directory }
    ]
  },
  {
    key: 'etkinlik-takvimi',
    label: 'Etkinlik Takvimi',
    icon: 'bx bx-calendar-event',
    description: 'Kurumsal etkinlikler ve özel günler',
    items: [
      { key: 'events', label: 'Etkinlik Takvimi', path: ROUTE_PATHS.events }
    ]
  },
  {
    key: 'yemekhane',
    label: 'Yemekhane',
    icon: 'bx bxs-dish',
    path: ROUTE_PATHS.cafeteria,
    description: 'Haftalık yemek menüsü ve servis saatleri',
    items: [
      { key: 'cafeteria', label: 'Yemekhane', path: ROUTE_PATHS.cafeteria }
    ]
  },
  // Müşteri talebiyle geçici olarak gizlendi (2026-06-22) — ileride geri açılabilir.
  // {
  //   key: 'insan-kariyer',
  //   label: 'İnsan ve Kariyer',
  //   icon: 'bx bxs-user',
  //   description: 'İK süreçleri ve çalışan yaşam döngüsü',
  //   items: [
  //     { key: 'hr', label: 'İK Merkezi', path: ROUTE_PATHS.hr },
  //     { key: 'applications', label: 'Başvurular', path: ROUTE_PATHS.applications, roles: ['super_admin', 'company_admin'] },
  //     { key: 'newEmployee', label: 'Yeni Çalışan Kaydı', path: ROUTE_PATHS.newEmployee, roles: ['super_admin', 'company_admin'] },
  //     { key: 'allEmployees', label: 'Tüm Çalışanlar', path: ROUTE_PATHS.allEmployees, roles: ['super_admin', 'company_admin'] }
  //   ]
  // },
  // Müşteri talebiyle geçici olarak gizlendi (2026-06-22) — ileride geri açılabilir.
  // {
  //   key: 'operasyonlar',
  //   label: 'Operasyonlar',
  //   icon: 'bx bxs-briefcase',
  //   description: 'Günlük talepler ve operasyonel yönetim',
  //   items: [
  //     { key: 'administrative', label: 'İdari İşler', path: ROUTE_PATHS.administrative },
  //     { key: 'selfService', label: 'Operasyonel Servisler', path: ROUTE_PATHS.selfService, requiresCompanyScope: true },
  //     { key: 'administrativeRequests', label: 'Taleplerim', path: ROUTE_PATHS.administrativeRequests },
  //     { key: 'administrativeStats', label: 'İstatistikler', path: ROUTE_PATHS.administrativeStats },
  //     { key: 'inventory', label: 'Zimmet Yönetimi', path: ROUTE_PATHS.inventory },
  //     { key: 'inventoryList', label: 'Zimmet Listesi', path: ROUTE_PATHS.inventoryList },
  //     { key: 'inventoryReports', label: 'Raporlar', path: ROUTE_PATHS.inventoryReports }
  //   ]
  // },
  {
    key: 'katilim-gelisim',
    label: 'Öneri ve Talep Kutusu',
    icon: 'bx bxs-bulb',
    description: 'Çalışan öneri ve talepleri',
    // Koloğlu Akademi menüden kaldırıldı (2026-06-22) — dashboard hızlı bağlantı
    // kartı olarak korunuyor (bkz. Faz 5).
    items: [
      { key: 'innovation', label: 'Öneri ve Talep Kutusu', path: ROUTE_PATHS.innovation }
    ]
  },
  {
    key: 'sistem',
    label: 'Sistem',
    icon: 'bx bxs-cog',
    description: 'Platform ve firma yönetimi',
    items: [
      {
        key: 'userRegistration',
        label: 'Kullanıcı Kayıt',
        path: ROUTE_PATHS.userRegistration,
        roles: ['super_admin', 'company_admin']
      },
      {
        key: 'contentAdmin',
        label: 'İçerik Yönetimi',
        path: ROUTE_PATHS.contentAdmin,
        roles: ['super_admin', 'company_admin']
      },
      {
        key: 'companyManagement',
        label: 'Firma Yönetimi',
        path: ROUTE_PATHS.companyManagement,
        roles: ['super_admin']
      }
    ]
  }
];

export const SEARCH_ITEMS = [
  {
    title: 'Anasayfa',
    url: ROUTE_PATHS.dashboard,
    type: 'Sayfa',
    keywords: ['anasayfa', 'dashboard', 'hızlı erişim']
  },
  {
    title: 'Duyurular',
    url: ROUTE_PATHS.announcements,
    type: 'Sayfa',
    keywords: ['duyuru', 'haber', 'bildirim']
  },
  {
    title: 'Doküman Merkezi',
    url: ROUTE_PATHS.documents,
    type: 'Sayfa',
    keywords: ['doküman', 'belge', 'dosya', 'form', 'prosedür', 'politika', 'şablon']
  },
  {
    title: 'Çalışan Rehberi',
    url: ROUTE_PATHS.directory,
    type: 'Sayfa',
    keywords: ['personel', 'çalışan', 'rehber', 'ekip']
  },
  {
    title: 'Yemekhane',
    url: ROUTE_PATHS.cafeteria,
    type: 'Sayfa',
    keywords: ['yemekhane', 'yemek', 'menü', 'öğle yemeği', 'kantin']
  },
  {
    title: 'Kullanıcı Kayıt',
    url: ROUTE_PATHS.userRegistration,
    type: 'Sayfa',
    keywords: ['kullanıcı', 'kayıt', 'çalışan ekle', 'excel', 'içe aktar', 'toplu']
  },
  {
    title: 'İnsan Kaynakları',
    url: ROUTE_PATHS.hr,
    type: 'Sayfa',
    keywords: ['ik', 'izin', 'masraf', 'başvuru']
  },
  {
    title: 'İdari İşler',
    url: ROUTE_PATHS.administrative,
    type: 'Sayfa',
    keywords: ['talep', 'kırtasiye', 'telefon', 'aksesuar']
  },
  {
    title: 'Operasyonel Servisler',
    url: ROUTE_PATHS.selfService,
    type: 'Sayfa',
    keywords: ['it destek', 'ticket', 'servis', 'ulaşım', 'yemekhane', 'sss', 'destek']
  },
  {
    title: 'Zimmet Yönetimi',
    url: ROUTE_PATHS.inventory,
    type: 'Sayfa',
    keywords: ['zimmet', 'envanter', 'malzeme', 'rapor']
  },
  {
    title: 'Etkinlik Takvimi',
    url: ROUTE_PATHS.events,
    type: 'Sayfa',
    keywords: ['etkinlik', 'takvim', 'organizasyon']
  },
  // Anketler müşteri talebiyle geçici olarak aramadan gizlendi (2026-07-01).
  // {
  //   title: 'Anketler',
  //   url: ROUTE_PATHS.surveys,
  //   type: 'Sayfa',
  //   keywords: ['anket', 'geri bildirim', 'memnuniyet']
  // },
  {
    title: 'Öneri ve Talep Kutusu',
    url: ROUTE_PATHS.innovation,
    type: 'Sayfa',
    keywords: ['öneri', 'inovasyon', 'fikir', 'talep']
  },
  {
    title: 'Firma Yönetimi',
    url: ROUTE_PATHS.companyManagement,
    type: 'Sayfa',
    keywords: ['firma', 'tenant', 'şirket', 'admin', 'süper admin']
  }
];

/** Anasayfa hero — günlük ihtiyaçlar; admin-only rotalar hariç */
export const DASHBOARD_HERO_ACTIONS = [
  { label: 'Duyurular', path: ROUTE_PATHS.announcements, icon: 'bx bxs-megaphone', variant: 'primary' },
  { label: 'Yemekhane Menüsü', path: ROUTE_PATHS.cafeteria, icon: 'bx bxs-dish' },
  { label: 'İzin Talebi', path: `${ROUTE_PATHS.hr}#izin-talep`, icon: 'bx bx-calendar' },
  { label: 'Masraf Bildirimi', path: `${ROUTE_PATHS.hr}#masraf-bildirim`, icon: 'bx bx-receipt' },
  { label: 'IT Destek', path: `${ROUTE_PATHS.selfService}#it-destek`, icon: 'bx bx-support' },
  { label: 'Servis ve Ulaşım', path: `${ROUTE_PATHS.selfService}#servis`, icon: 'bx bxs-bus' },
  { label: 'Teknik SSS', path: `${ROUTE_PATHS.selfService}#teknik-sss`, icon: 'bx bxs-help-circle' },
  { label: 'Çalışan Rehberi', path: ROUTE_PATHS.directory, icon: 'bx bxs-group' },
  { label: 'Doküman Merkezi', path: ROUTE_PATHS.documents, icon: 'bx bxs-file-doc' },
  {
    label: 'Politika ve Prosedürler',
    path: `${ROUTE_PATHS.documents}?kategori=politika-prosedur`,
    icon: 'bx bxs-book'
  },
  {
    label: 'Formlar ve Şablonlar',
    path: `${ROUTE_PATHS.documents}?kategori=form-sablon`,
    icon: 'bx bxs-copy'
  },
  { label: 'İdari İşler', path: ROUTE_PATHS.administrative, icon: 'bx bxs-briefcase' },
  { label: 'Taleplerim', path: ROUTE_PATHS.administrativeRequests, icon: 'bx bxs-folder-open' },
  { label: 'Etkinlik Takvimi', path: ROUTE_PATHS.events, icon: 'bx bx-calendar-event' },
  // Anketler müşteri talebiyle geçici olarak hero kısayollarından gizlendi (2026-07-01).
  // { label: 'Anketler', path: ROUTE_PATHS.surveys, icon: 'bx bx-task' },
  { label: 'Öneri Kutusu', path: ROUTE_PATHS.innovation, icon: 'bx bxs-bulb' },
  { label: 'Profilim', path: ROUTE_PATHS.profile, icon: 'bx bxs-user' },
  {
    label: 'Koloğlu Akademi',
    path: ORGANIZATION_BRAND.academyUrl,
    icon: 'bx bxs-graduation',
    external: true
  }
];

// Hızlı Erişim kartı — yalnızca erişilebilir (gizlenmemiş) modüllere kısayol.
// İnsan ve Kariyer (Faz 1) ve Operasyonlar (Faz 2) gizlendiği için İK, İdari İşler,
// Operasyonel Servisler, Zimmet, Taleplerim kısayolları çıkarıldı.
export const DASHBOARD_QUICK_LINKS = [
  {
    label: 'Duyurular',
    path: ROUTE_PATHS.announcements,
    icon: 'bx bxs-megaphone'
  },
  {
    label: 'Doküman Merkezi',
    path: ROUTE_PATHS.documents,
    icon: 'bx bxs-file-doc'
  },
  {
    label: 'Çalışan Rehberi',
    path: ROUTE_PATHS.directory,
    icon: 'bx bxs-group'
  },
  {
    label: 'Etkinlik Takvimi',
    path: ROUTE_PATHS.events,
    icon: 'bx bx-calendar-event'
  },
  // Anketler müşteri talebiyle geçici olarak hızlı erişimden gizlendi (2026-07-01).
  // {
  //   label: 'Anketler',
  //   path: ROUTE_PATHS.surveys,
  //   icon: 'bx bx-task'
  // },
  {
    label: 'Öneri ve Talep Kutusu',
    path: ROUTE_PATHS.innovation,
    icon: 'bx bxs-bulb'
  },
  {
    label: 'Profil',
    path: ROUTE_PATHS.profile,
    icon: 'bx bxs-user'
  }
];
